import { lazy, Suspense } from "react";
import { Routes, Route, HashRouter, Navigate, useParams } from "react-router-dom";
import { NewAuthProvider } from "./contexts/NewAuthContext";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import NewProtectedRoute from "./components/NewProtectedRoute";
import RouteTracker from "./components/RouteTracker";



// New Modern Components

import NewApiLogin from "./view/Inicio/UnifiedLogin";

// Carga diferida: cada pantalla se descarga solo al visitarla
const Calculadora = lazy(() => import("./view/Calculadora/Calculadora"));
const CuadreCajaadd = lazy(() => import("./view/CuadreCaja/Caudrecajaadd"));
const Cliente = lazy(() => import("./view/Clientes/Cliente"));
const ClienteCastigar = lazy(() => import("./view/Clientes/ClienteCastigar"));
// La antigua pantalla de documentos ahora es la sección "Documentos" del detalle del cliente
const RedirigirADocumentos = () => <Navigate to={`/clientes/ver/${useParams().id}`} replace />;
const ClienteEdit = lazy(() => import("./view/Clientes/ClienteEdit"));
const ClienteNotas = lazy(() => import("./view/Clientes/ClienteNotas"));
const Clientes = lazy(() => import("./view/Clientes/Clientes"));
const ClientesEditar = lazy(() => import("./view/Clientes/ClientesEditar"));
const ClienteVer = lazy(() => import("./view/Clientes/ClienteVer"));
const ClientesActivosD = lazy(() => import("./view/Clientes/ClientesActivosDate"));
const ClientesAsesorCastigados = lazy(() => import("./view/Clientes/ClientesAsesorCastigados"));
const ClientesRegistro = lazy(() => import("./view/Clientes/ClientesRegistro"));
const ClientesRegistroModern = lazy(() => import("./view/Clientes/ClientesRegistroModern"));
const CobranzaDiaria = lazy(() => import("./view/CobranzaDiaria/CobranzaDiaria"));
const CuadreCaja = lazy(() => import("./view/CuadreCaja/Cuadrecaja"));
const Cuadrecajaview = lazy(() => import("./view/CuadreCaja/Cuadrecajaview"));
const Egresos = lazy(() => import("./view/Egresos/Egresos"));
const InicioPage = lazy(() => import("./view/Inicio/Inicio"));
const JuntaAdd = lazy(() => import("./view/Junta/JuntaAdd"));
const JuntaDetail = lazy(() => import("./view/Junta/JuntaDetail"));
const JuntaHoy = lazy(() => import("./view/Junta/JuntaHoy"));
const JuntaPlanAdd = lazy(() => import("./view/JuntaPlan/JuntaPlanAdd"));
const JuntaPlanDetail = lazy(() => import("./view/JuntaPlan/JuntaPlanDetail"));
const JuntasModern = lazy(() => import("./components/JuntasModern"));
const JuntaPlanModern = lazy(() => import("./components/JuntaPlanModern"));
const NewUsersModern = lazy(() => import("./view/Usuarios/NewUsersModern"));
const NewPres = lazy(() => import("./view/NewPres"));
const NewPresList = lazy(() => import("./view/NewPresList"));
const PagosOtrosList = lazy(() => import("./view/PagosOtros/PagosOtrosList"));
const PagosOtrosModern = lazy(() => import("./view/PagosOtros/PagosOtrosModern"));
const NotificacionesHistorial = lazy(() => import("./view/Notifications/NotificacionesHistorial"));
const ReportesDashboard = lazy(() => import("./components/reports/ReportesDashboard"));
const PerfilPage = lazy(() => import("./view/Usuarios/PerfilModern"));
const PerfilEdit = lazy(() => import("./view/Usuarios/PerfilEdit"));
const PerfilEditPass = lazy(() => import("./view/Usuarios/PerfilEditPass"));
const ProjectProgress = lazy(() => import("./view/Project/ProjectProgress"));
const DevTaskManager = lazy(() => import("./view/Project/DevTaskManager"));
const Prestamo = lazy(() => import("./view/Prestamos/Prestamo"));
const PrestamoDetailModern = lazy(() => import("./view/Prestamos/PrestamoDetailModern"));
const PrestamoRcc = lazy(() => import("./view/Prestamos/PrestamoRcc"));
const PrestamoCastigar = lazy(() => import("./view/Prestamos/PrestamoCastigar"));
const Prestamos = lazy(() => import("./view/Prestamos/Prestamos"));
const PrestamosActivos = lazy(() => import("./view/Prestamos/PrestamosActivos"));
const PrestamosAdd = lazy(() => import("./view/Prestamos/PrestamosAdd"));
const PrestamosAll = lazy(() => import("./view/Prestamos/PrestamosAll"));
const PrestamosCanceladosHoy = lazy(() => import("./view/Prestamos/PrestamosCancelados"));
const PrestamosCastigados = lazy(() => import("./view/Prestamos/PrestamosCastigados"));
const PrestamosDocument = lazy(() => import("./view/Prestamos/PrestamosDocument"));
const PrestamosRegister = lazy(() => import("./view/Prestamos/PrestamosRegisterModern"));
const ReportesCarteraA = lazy(() => import("./view/Reportes/ReporteCarteraActiva"));
const ReportesClienAct = lazy(() => import("./view/Reportes/ReporteClienAct"));
const ReportesMora = lazy(() => import("./view/Reportes/ReporteMora"));
const Reportes = lazy(() => import("./view/Reportes/Reportes"));
const ReportesCierreMes = lazy(() => import("./view/Reportes/ReportesCierreMes"));
const ReportesColocacion = lazy(() => import("./view/Reportes/ReportesColocacion"));
const ReportesInfoCont = lazy(() => import("./view/Reportes/ReportesInfoCont"));
const ReportesIngFi = lazy(() => import("./view/Reportes/ReportesIngFi"));
const ReportesIngresosFinancieros = lazy(() => import("./view/Reportes/ReportesIngresosFinancieros"));
const ReportesAntiguos = lazy(() => import("./view/Reportes/ReportesAntiguos"));
const ReportesRecuperaciones = lazy(() => import("./view/Reportes/ReportesRecuperaciones"));
const ReporteCarteraActivaModern = lazy(() => import("./view/Reportes/ReporteCarteraActivaModern"));
const ReporteCarteraMoraModern = lazy(() => import("./view/Reportes/ReporteCarteraMoraModern"));
const ReporteClientesActivosModern = lazy(() => import("./view/Reportes/ReporteClientesActivosModern"));
const ReportesJunta = lazy(() => import("./view/Reportes/ReportesJunta"));
const ReportesPagosO = lazy(() => import("./view/Reportes/ReportesPagosO"));
const ReportesRecu = lazy(() => import("./view/Reportes/ReportesRecu"));
const ReporteClientes = lazy(() => import("./view/Reportes/ReporteClientes"));
const ReporteReengancheModern = lazy(() => import("./view/Reportes/ReporteReengancheModern"));
const ReporteCosechasModern = lazy(() => import("./view/Reportes/ReporteCosechasModern"));
const ReporteParTramosModern = lazy(() => import("./view/Reportes/ReporteParTramosModern"));
const ReporteProductividadAsesorModern = lazy(() => import("./view/Reportes/ReporteProductividadAsesorModern"));
const ReporteClientesInactivosModern = lazy(() => import("./view/Reportes/ReporteClientesInactivosModern"));
const ReporteFlujoCobranzaModern = lazy(() => import("./view/Reportes/ReporteFlujoCobranzaModern"));
const ReporteRentabilidadProductoModern = lazy(() => import("./view/Reportes/ReporteRentabilidadProductoModern"));
const ReporteTelemetriaModern = lazy(() => import("./view/Reportes/ReporteTelemetriaModern"));
const Usuarios = lazy(() => import("./view/Usuarios/UsersModern"));
const CajasModern = lazy(() => import("./view/Cajas/CajasModern"));
const MovimientosCajaModern = lazy(() => import("./view/Cajas/MovimientosCajaModern"));
const Home = lazy(() => import("./view/Inicio/HomeModern"));
const PrestamosSearch = lazy(() => import("./view/Prestamos/PrestamosSearchModern"));
const ReportesGeneral = lazy(() => import("./view/Reportes/ReportesGeneral"));
const PagosOtrosAdd = lazy(() => import("./view/PagosOtros/PagosOtrosAgregar"));
const PagosTodosModern = lazy(() => import("./view/Pagos/PagosTodosModern"));
const PagosModern = lazy(() => import("./view/Pagos/PagosModern"));
const PagoRealizar = lazy(() => import("./view/Pagos/PagoRealizar"));
const PagosMultiples = lazy(() => import("./view/Pagos/PagosMultiples"));
const ReportesCuadreCaja = lazy(() => import("./view/Reportes/ReportesCuadreCaja"));
const ReportesCuadreCajaNew = lazy(() => import("./view/Reportes/ReportesCuadreCajaNew"));
const ReportesCierreMesNew = lazy(() => import("./view/Reportes/ReportesCierreMesNew"));
const PagosHistorial = lazy(() => import("./view/Pagos/PagosHistorial"));
const PagosHistorialModern = lazy(() => import("./view/Pagos/PagosHistorialModern"));
const PreEvaluacioCredito = lazy(() => import("./view/PreEvaluacion/PreEvaluacion"));
const ReporteMoraDetail = lazy(() => import("./view/Reportes/ReporteMoraDetalle"));
const PrestamosReasignar = lazy(() => import("./view/Prestamos/PrestamosReasignar"));
const ReportesCierreMesNewUser = lazy(() => import("./view/Reportes/ReportesCierreMesNewUser"));
const IngresosCajaModern = lazy(() => import("./components/IngresosCajaModern"));
const NotasCajaModern = lazy(() => import("./components/NotasCajaModern"));
const DepositosCuadreModern = lazy(() => import("./components/DepositosCuadreModern"));
const EntregaEfectivoModern = lazy(() => import("./components/EntregaEfectivoModern"));
const SueldosModern = lazy(() => import("./components/SueldosModern"));
const ReportesIngFiDetalle = lazy(() => import("./view/Reportes/ReportesIngFiDetalle"));
const ReportesRecuDetalle = lazy(() => import("./view/Reportes/ReportesRecuDetalle"));
const ReportesColocacionDetalle = lazy(() => import("./view/Reportes/ReportesColocacionDetalle"));
const ReportesClienActDetalle = lazy(() => import("./view/Reportes/ReportesClienActDetalle"));
const ReportesPagoODetalle = lazy(() => import("./view/Reportes/ReportesPagoODetalle"));
const ReportesCarteraActivaDetalle = lazy(() => import("./view/Reportes/ReportesCarteraActivaDetalle"));
const ReportesGeneralInfocorp = lazy(() => import("./view/Reportes/ReportesGeneralInfocorp"));
const PrestamosEditar = lazy(() => import("./view/Prestamos/PrestamosEditar"));
const PagosTemporalesModern = lazy(() => import("./view/PagosTemporales/PagosTemporalesModern"));
const PagoTemporalForm = lazy(() => import("./view/PagosTemporales/PagoTemporalForm"));
const Feriados = lazy(() => import("./view/Feriados/Feriados"));
const FeriadoAdd = lazy(() => import("./view/Feriados/FeriadoAdd"));
const FeriadoEdit = lazy(() => import("./view/Feriados/FeriadoEdit"));
const AuditoriaModern = lazy(() => import("./view/Auditoria/AuditoriaModern"));
const AdminAnuncios = lazy(() => import("./view/Anuncios/AdminAnuncios"));
const DashboardReports = lazy(() => import("./view/Reportes/ReportesV2/DashboardReports"));
const DashboardEjecutivo = lazy(() => import("./view/Reportes/ReportesV2/DashboardEjecutivo"));
const AnalisisCartera = lazy(() => import("./view/Reportes/ReportesV2/AnalisisCartera"));
const RendimientoCobranza = lazy(() => import("./view/Reportes/ReportesV2/RendimientoCobranza"));
const AnalisisClientes = lazy(() => import("./view/Reportes/ReportesV2/AnalisisClientes"));
const ReportesPersonalizados = lazy(() => import("./view/Reportes/ReportesV2/ReportesPersonalizados"));
const ScoringRules = lazy(() => import("./view/Clientes/ScoringRules"));



// Importar Reportes V2

// Crear tema básico para MUI
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#fff',
    },
    secondary: {
      main: '#dc004e',
      light: '#f50057',
      dark: '#c51162',
      contrastText: '#fff',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    warning: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#f57c00',
      contrastText: '#000',
    },
    info: {
      main: '#2196f3',
      light: '#64b5f6',
      dark: '#1976d2',
      contrastText: '#fff',
    },
    success: {
      main: '#4caf50',
      light: '#81c784',
      dark: '#388e3c',
      contrastText: '#fff',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
    background: {
      default: '#fafafa',
      paper: '#fff',
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      hover: 'rgba(0, 0, 0, 0.04)',
      selected: 'rgba(0, 0, 0, 0.08)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.125rem',
      fontWeight: 300,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 400,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.875rem',
    },
  },
  shape: {
    borderRadius: 4,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NewAuthProvider>
        <HashRouter>
            <RouteTracker />
            <Suspense fallback={<div style={{ padding: 24, textAlign: "center" }}>Cargando...</div>}>
            <Routes>
          {/* Login Unificado */}
          <Route path="/" element={<NewApiLogin />} />
          <Route path="/login" element={<NewApiLogin />} />
          
          {/* Rutas de migración temporal (mantener por compatibilidad) */}
          
          {/* Rutas protegidas */}
          <Route path="/home" element={
            <NewProtectedRoute>
              <Home />
            </NewProtectedRoute>
          } />
          <Route path="/inicio" element={
            <NewProtectedRoute>
              <InicioPage />
            </NewProtectedRoute>
          } />
          <Route path="/miperfil" element={
            <NewProtectedRoute>
              <PerfilPage />
            </NewProtectedRoute>
          } />
          <Route path="/miperfiledit" element={
            <NewProtectedRoute>
              <PerfilEdit />
            </NewProtectedRoute>
          } />
          <Route path="/miperfileditpass" element={
            <NewProtectedRoute>
              <PerfilEditPass />
            </NewProtectedRoute>
          } />
        <Route path="/usuarios" element={
          <NewProtectedRoute requiredRoles={[1]}>
            <Usuarios />
          </NewProtectedRoute>
        } />

        {/* Rutas de Cajas - Solo para Administradores */}
        <Route path="/cajas" element={
          <NewProtectedRoute requiredRoles={[1]}>
            <CajasModern />
          </NewProtectedRoute>
        } />
        <Route path="/cajas/:cajaId/movimientos" element={
          <NewProtectedRoute requiredRoles={[1]}>
            <MovimientosCajaModern />
          </NewProtectedRoute>
        } />
        <Route path="/movimientos-caja" element={
          <NewProtectedRoute requiredRoles={[1]}>
            <MovimientosCajaModern />
          </NewProtectedRoute>
        } />

        <Route path="/prestamos" element={
          <NewProtectedRoute>
            <Prestamos />
          </NewProtectedRoute>
        } />
        <Route path="/prestamos-search" element={
          <NewProtectedRoute>
            <PrestamosSearch />
          </NewProtectedRoute>
        } />
        <Route path="/prestamos-castigados" element={
          <NewProtectedRoute>
            <PrestamosCastigados />
          </NewProtectedRoute>
        } />
        <Route path="/prestamosall" element={
          <NewProtectedRoute>
            <PrestamosAll />
          </NewProtectedRoute>
        } />
        <Route path="/prestamosactivos" element={
          <NewProtectedRoute>
            <PrestamosActivos />
          </NewProtectedRoute>
        } />
        <Route path="/prestamos-cancelados-hoy" element={
          <NewProtectedRoute>
            <PrestamosCanceladosHoy />
          </NewProtectedRoute>
        } />
        <Route path="/prestamosadd" element={
          <NewProtectedRoute>
            <PrestamosAdd />
          </NewProtectedRoute>
        } />
        <Route path="/PrestamoRegister/:id" element={
          <NewProtectedRoute>
            <PrestamosRegister />
          </NewProtectedRoute>
        } />
        <Route path="/prestamo/:id" element={
          <NewProtectedRoute>
            <PrestamoDetailModern />
          </NewProtectedRoute>
        } />
        <Route path="/prestamorcc/:id" element={
          <NewProtectedRoute>
            <PrestamoRcc />
          </NewProtectedRoute>
        } />
        <Route path="/prestamo-castigar/:id" element={
          <NewProtectedRoute>
            <PrestamoCastigar />
          </NewProtectedRoute>
        } />
        <Route path="/PrestamoDocument/:id" element={
          <NewProtectedRoute>
            <PrestamosDocument />
          </NewProtectedRoute>
        } />

        <Route path="/reportes" element={<Reportes />} />
        <Route path="/reportes-clientes" element={<ReporteClientes />} />
        
        {/* Reportes V2 - Dashboard Analítico */}
        <Route path="/reportes-v2" element={<DashboardReports />} />
        <Route path="/reportes-v2/dashboard-ejecutivo" element={<DashboardEjecutivo />} />
        <Route path="/reportes-v2/analisis-cartera" element={<AnalisisCartera />} />
        <Route path="/reportes-v2/rendimiento-cobranza" element={<RendimientoCobranza />} />
        <Route path="/reportes-v2/analisis-clientes" element={<AnalisisClientes />} />
        <Route path="/reportes-v2/reportes-personalizados" element={<ReportesPersonalizados />} />
        
        <Route
          path="/reportes-ingresos-financieros"
          element={<ReportesIngFi />}
        />
        <Route path="/reportes-recuperaciones" element={<ReportesRecu />} />
        <Route path="/reportes-junta" element={<ReportesJunta />} />
        <Route path="/reportes-contadora" element={<ReportesInfoCont />} />
        <Route
          path="/reportes-clientes-activos"
          element={<ReportesClienAct />}
        />
        <Route
          path="/reportes-clientes-activos-date"
          element={<ClientesActivosD />}
        />
        <Route path="/reportes-pagos-otros" element={<ReportesPagosO />} />
        <Route path="/reporte-mora" element={<ReportesMora />} />
        <Route path="/reporte-cartera-activa" element={<ReportesCarteraA />} />
        <Route path="/reporte-colocacion" element={<ReportesColocacion />} />

        <Route path="/cuadre-caja" element={<CuadreCaja />} />
        <Route path="/cuadre-caja/:id" element={<Cuadrecajaview />} />
        <Route path="/cuadre-caja-agregar" element={<CuadreCajaadd />} />

        <Route path="/nuevos-prestamos" element={<NewPres />} />
        <Route path="/nuevos-prestamos/:id" element={<NewPresList />} />

        <Route path="/pagos-otros" element={<PagosOtrosModern />} />
        <Route path="/pagos-otros-list" element={<PagosOtrosList />} />

        <Route path="/clientes" element={<Clientes />} />
        <Route path="/scoring-rules" element={
          <NewProtectedRoute>
            <ScoringRules />
          </NewProtectedRoute>
        } />
        <Route path="/clientes/editar/:id" element={<ClientesEditar />} />
        <Route path="/clientes/ver/:id" element={
          <NewProtectedRoute>
            <ClienteVer />
          </NewProtectedRoute>
        } />
        <Route path="/clientesRegistro" element={<ClientesRegistro />} />
        <Route path="/clientesRegistroModern" element={<ClientesRegistroModern />} />
        <Route path="/cliente/:id" element={<Cliente />} />
        <Route path="/clienteDocument/:id" element={<RedirigirADocumentos />} />
        <Route
          path="/clientes-asesor-castigados/:id"
          element={<ClientesAsesorCastigados />}
        />
        <Route path="/ClienteCastigar/:id" element={<ClienteCastigar />} />
        <Route path="/ClienteNotas/:id" element={<ClienteNotas />} />

        <Route path="/junta" element={<JuntasModern />} />
        <Route path="/junta-hoy" element={<JuntaHoy />} />
        <Route path="/junta-detalle/:id" element={<JuntaDetail />} />
        {/* Mantener rutas antiguas para compatibilidad */}
        <Route path="/junta-agregar" element={<JuntaAdd />} />
        <Route path="/juntaplan" element={<JuntaPlanModern />} />
        <Route path="/juntaplan/:id" element={<JuntaPlanDetail />} />
        {/* Mantener rutas antiguas para compatibilidad */}
        <Route path="/juntaplan-ver/:id" element={<JuntaPlanDetail />} />
        <Route path="/junta-plan-agregar" element={<JuntaPlanAdd />} />

        <Route path="/egresos" element={<Egresos />} />
        <Route path="/calculadora" element={<Calculadora />} />
        <Route path="/cobranza-diaria" element={<CobranzaDiaria />} />

        <Route path="/pagos/:id" element={<PagosModern />} />
        <Route path="/pagos-todos/:id" element={<PagosTodosModern />} />
        <Route path="/pagos-historial/:id" element={<PagosHistorialModern />} />

        <Route path="/realizar-pago/:id" element={<PagoRealizar />} />
        <Route path="/pagos-otros-agregar" element={<PagosOtrosAdd />} />
        <Route path="/pagos-varios/:id" element={<PagosMultiples />} />
        <Route path="/reporte-cuadre-caja" element={<ReportesCuadreCaja />} />
        <Route
          path="/reporte-cuadre-caja-new"
          element={<ReportesCuadreCajaNew />}
        />
        <Route path="/pagos-temporales" element={<PagosTemporalesModern />} />
        <Route path="/pagos-temporales/agregar" element={<PagoTemporalForm />} />
        <Route path="/reporte-new-cierre" element={<ReportesCierreMesNew />} />
        <Route
          path="/pre-evaluacion"
          element={<PreEvaluacioCredito />}
        />
        <Route path="/reportes-mora-detalle" element={<ReporteMoraDetail />} />
        <Route path="/prestamos-reasignar" element={<PrestamosReasignar />} />
        <Route path="/reporte-new-cierre/:id" element={<ReportesCierreMesNewUser />} />
        <Route path="/cuadre-caja/ingresos" element={<IngresosCajaModern />} />
        <Route path="/cuadre-caja/notas" element={<NotasCajaModern />} />
        <Route path="/cuadre-caja/deposito" element={<DepositosCuadreModern />} />
        <Route path="/cuadre-caja/entrega-efectivo" element={<EntregaEfectivoModern />} />
        <Route path="/cuadre-caja/sueldos" element={<SueldosModern />} />

        <Route path="/reporte/ingresos-financieros/detalle" element={<ReportesIngFiDetalle />} />
        <Route path="/reportes/ingresos-financieros" element={<ReportesIngresosFinancieros />} />
        <Route path="/reportes-antiguos" element={<ReportesAntiguos />} />
        <Route path="/reporte-reenganche" element={
          <NewProtectedRoute>
            <ReporteReengancheModern />
          </NewProtectedRoute>
        } />
        <Route path="/reporte-cosechas" element={
          <NewProtectedRoute>
            <ReporteCosechasModern />
          </NewProtectedRoute>
        } />
        <Route path="/reporte-par-tramos" element={
          <NewProtectedRoute>
            <ReporteParTramosModern />
          </NewProtectedRoute>
        } />
        <Route path="/reporte-productividad-asesor" element={
          <NewProtectedRoute>
            <ReporteProductividadAsesorModern />
          </NewProtectedRoute>
        } />
        <Route path="/reporte-clientes-inactivos" element={
          <NewProtectedRoute>
            <ReporteClientesInactivosModern />
          </NewProtectedRoute>
        } />
        <Route path="/reporte-flujo-cobranza" element={
          <NewProtectedRoute>
            <ReporteFlujoCobranzaModern />
          </NewProtectedRoute>
        } />
        <Route path="/reporte-rentabilidad-producto" element={
          <NewProtectedRoute>
            <ReporteRentabilidadProductoModern />
          </NewProtectedRoute>
        } />
        <Route path="/reportes/recuperaciones" element={<ReportesRecuperaciones />} />
        <Route path="/reportes/cartera-activa" element={
          <NewProtectedRoute>
            <ReporteCarteraActivaModern />
          </NewProtectedRoute>
        } />
        <Route path="/reportes/clientes-activos" element={
          <NewProtectedRoute>
            <ReporteClientesActivosModern />
          </NewProtectedRoute>
        } />
        <Route path="/reportes/cartera-mora" element={
          <NewProtectedRoute>
            <ReporteCarteraMoraModern />
          </NewProtectedRoute>
        } />
        <Route path="/reportes/telemetria" element={
          <NewProtectedRoute>
            <ReporteTelemetriaModern />
          </NewProtectedRoute>
        } />
        <Route path="/reporte/recuperaciones/detalle" element={<ReportesRecuDetalle />} />
        <Route path="/reporte/colocaiones/detalle" element={<ReportesColocacionDetalle />} />
        <Route path="/reporte/clientesActivos/detalle" element={<ReportesClienActDetalle />} />
        <Route path="/reporte/pagosOtros/detalle" element={
          <NewProtectedRoute>
            <ReportesPagoODetalle />
          </NewProtectedRoute>
        } />
        <Route path="/reporte/carteraActiva/detalle" element={
          <NewProtectedRoute>
            <ReportesCarteraActivaDetalle />
          </NewProtectedRoute>
        } />
        <Route path="/reporte/infocorp" element={
          <NewProtectedRoute>
            <ReportesGeneralInfocorp />
          </NewProtectedRoute>
        } />

        <Route path="/feriados" element={
          <NewProtectedRoute>
            <Feriados />
          </NewProtectedRoute>
        } />

        <Route path="/feriado-agregar" element={
          <NewProtectedRoute>
            <FeriadoAdd />
          </NewProtectedRoute>
        } />

        <Route path="/feriado-editar/:id" element={
          <NewProtectedRoute>
            <FeriadoEdit />
          </NewProtectedRoute>
        } />

        <Route path="/auditoria" element={
          <NewProtectedRoute requiredRoles={[1]}>
            <AuditoriaModern />
          </NewProtectedRoute>
        } />

        <Route path="/anuncios" element={
          <NewProtectedRoute requiredRoles={[1]}>
            <AdminAnuncios />
          </NewProtectedRoute>
        } />

        {/* === NUEVAS RUTAS CON API LARAVEL === */}
        {/* Rutas públicas */}
        
        {/* Rutas protegidas con nueva API */}

        {/* Rutas de Historial de Notificaciones */}
        <Route path="/notificaciones-historial" element={
          <NewProtectedRoute>
            <NotificacionesHistorial />
          </NewProtectedRoute>
        } />

        {/* Ruta Gestor de Tareas de Desarrollo y Progreso del Proyecto */}
        <Route path="/dev-tasks" element={
          <NewProtectedRoute>
            <DevTaskManager />
          </NewProtectedRoute>
        } />
            </Routes>
            </Suspense>
          </HashRouter>
        </NewAuthProvider>
      </ThemeProvider>
  );
}

export default App;
